import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传图片", -1)

import { ref, reactive, computed, watch } from 'vue'
import { createSortList, editSortList, deleteSortList } from '@/services/appreciation'
import { uploadFileToOss } from '@/utils/oss'
import { PlusOutlined } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { useRouter } from 'vue-router'


export default {
  props: {
  current: {
    type: Object
  },
  treeData: {
    type: Array,
    default: () => []
  }
},
  emits: ['onSave'],
  setup(__props, { emit }) {

const props = __props
const router = useRouter()





const formRef = ref()

const pageState = reactive({
  uploadLoading: false
})

const fileList = ref([])

const labelCol = { span: 4 }
const wrapperCol = { span: 17 }

const formState = computed(() => props.current)

watch(() => formState.value, (val) => {
  if (val.cover_image_url) {
    fileList.value = [{ url: val.cover_image_url, status: 'done' }]
  } else {
    fileList.value = []
  }
  formState.value.pid = val.path
})

const title = computed(() => props.current?.id ? '编辑分类' : '新建分类')

const treeData = computed(() => props.treeData)

const handleReset = () => {
  emit('onSave')
  pageState.title = '新建分类'
  pageState.uploadLoading = false

  formState.value = { pid: [0] }
  fileList.value = []
}

const handleSave = async () => {
  await formRef.value.validate()
  try {
    formState.value.cover_image_url = fileList.value[0]?.url || ''
    const params = {}
    params.name = formState.value.name
    params.cover_image_url = formState.value.cover_image_url
    params.order_index = formState.value.order_index
    params.id = formState.value.id
    // params.pid = formState.value.pid?.at(-1) ?? 0
    params.pid = formState.value.pid ? formState.value.pid[formState.value.pid.length - 1] ?? 0 : 0

    if (params.id) {
      await editSortList(params.id, params)
    } else {
      await createSortList(params)
    }

    message.success('保存成功')
    handleReset()
  } catch (e) {
    message.success('保存失败')
    console.error(e)
  }
}

const handleDelete = async () => {
  try {
    await deleteSortList(formState.value.id)
    message.success('删除成功')
    handleReset()
  } catch (e) {
    message.error('删除失败')
    console.error(e)
  }
}

const goBack = () => {
  router.go(-1)
}

const handleUpload = (info) => {
  const { file } = info
  const reader = new FileReader()
  reader.readAsDataURL(file)
  reader.onload = () => {
    try {
      uploadFileToOss(file).then(data => {
        const { url } = data
        if (fileList.value.length > 1) {
          fileList.value.shift()
        }
        fileList.value.forEach(item => {
          if (item.name === file.name) {
            item.url = url
            item.status = 'done'
          }
        })
      })
    } catch (e) {
      console.error(e)
    }
  }
}


return (_ctx, _cache) => {
  const _component_a_button = _resolveComponent("a-button")
  const _component_a_input = _resolveComponent("a-input")
  const _component_a_form_item = _resolveComponent("a-form-item")
  const _component_a_upload = _resolveComponent("a-upload")
  const _component_a_cascader = _resolveComponent("a-cascader")
  const _component_a_form = _resolveComponent("a-form")
  const _component_a_card = _resolveComponent("a-card")

  return (_openBlock(), _createBlock(_component_a_card, {
    bordered: "",
    title: _unref(title),
    style: {height:'100%'}
  }, {
    extra: _withCtx(() => [
      _createVNode(_component_a_button, {
        type: "primary",
        onClick: handleSave
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _withDirectives(_createVNode(_component_a_button, {
        type: "danger",
        onClick: handleDelete,
        style: {"margin-left":"8px"}
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 512), [
        [_vShow, _unref(formState)?.id]
      ]),
      _createVNode(_component_a_button, {
        onClick: goBack,
        style: {"margin-left":"8px"}
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_form, {
        ref: (_value, _refs) => {
          _refs['formRef'] = _value
          formRef.value = _value
        },
        model: _unref(formState),
        labelCol: labelCol,
        wrapperCol: wrapperCol
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            name: "name",
            label: "分类名称",
            rules: [{ required: true, message: '请输入分类名称' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _unref(formState).name,
                "onUpdate:value": _cache[0] || (_cache[0] = $event => (_unref(formState).name = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "order_index",
            label: "排序"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input, {
                value: _unref(formState).order_index,
                "onUpdate:value": _cache[1] || (_cache[1] = $event => (_unref(formState).order_index = $event))
              }, null, 8, ["value"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "cover_image_url",
            label: "封面"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_upload, {
                "file-list": fileList.value,
                "onUpdate:file-list": _cache[2] || (_cache[2] = $event => (fileList.value = $event)),
                "list-type": "picture-card",
                accept: ".png, .jpg, .jpeg",
                customRequest: handleUpload
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(PlusOutlined)),
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["file-list"])
            ]),
            _: 1
          }),
          _createVNode(_component_a_form_item, {
            name: "pid",
            label: "选择父级分类"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_cascader, {
                allowClear: false,
                defaultValue: [0],
                value: _unref(formState).pid,
                "onUpdate:value": _cache[3] || (_cache[3] = $event => (_unref(formState).pid = $event)),
                options: _unref(treeData),
                placeholder: "请选择父级分类",
                expandTrigger: "hover",
                "change-on-select": "",
                fieldNames: {value:'key', label:'title', children:'children'}
              }, null, 8, ["value", "options"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

}